export const STATUS_NEW = 1;
export const STATUS_AWAITING_MENTOR_APPROVAL = 3;    // submitted to mentors for approval
export const STATUS_MENTOR_RESPONSE = 4;             // mentor rejected
export const STATUS_OPEN = 5;                        // claimed and open.. assistant should be working
export const STATUS_AWAITING_RESPONSE = 7;           // UNUSED? 
export const STATUS_CLIENT_RESPONSE = 10;            // the client has said something!!!
export const STATUS_AWAITING_THIRD_PARTY = 11;       // waiting for someone else or some delay.
export const STATUS_AWAITING_MANAGER_RESPONSE = 12;  // needs a manager to do something!
export const STATUS_THIRD_PARTY_RESPONSE = 13;       // third party got back to us
export const STATUS_CALLNUT_AWAITING_TIMER = 14;     
export const STATUS_CALLNUT_TIMER_UP = 15;
export const STATUS_CLOSED = 20; 
export const STATUS_EXPIRED = 21;


